<template>
  <!--  管理员-教育机关查看列表ー编辑 -->
  <div class="main-css">
    <!--  标题-->
    <div class="title-css">{{ $t("eduInstitutionManagement") }}</div>
    <div class="main-box">
      <!-- button 部分 -->
      <div class="line-button-box">
        <el-button class="button-css" @click="handleAddClick">{{
          $t("new")
        }}</el-button>
        <el-dropdown @command="handleUpdateAppStatus">
          <el-button type="primary" class="button-css">
            {{ $t("changeState") }}
          </el-button>
          <el-dropdown-menu slot="dropdown">
            <el-dropdown-item
              v-for="(item1, index) in statusData"
              :key="item1.code"
              :command="item1"
              >{{ item1.name }}
            </el-dropdown-item>
          </el-dropdown-menu>
        </el-dropdown>
        <el-button class="button-css" @click="deleteEducationInfo">{{
          $t("delete")
        }}</el-button>
      </div>
      <!--    表格部分-->
      <div class="table">
        <el-table
          ref="multipleTable"
          :data="tableData"
          style="width: 95%;"
          height="400"
          @row-click="rowClick"
          @cell-click="tableCellClick"
          :cell-class-name="
            ({ row, column, rowIndex, columnIndex }) => (
              (row.index = rowIndex), (column.index = columnIndex)
            )
          "
          @selection-change="handleSelectionChange"
          @sort-change="changeTableSort" v-loading="loading" empty-text=" " >
          <!--------------选择框----------------->
          <el-table-column type="selection" width="45"></el-table-column>
          <!--------------機関番号----------------->
          <el-table-column
            prop="educationId"
            label="機関番号"
            width="130"
            @cell-click="rowClick"
            :show-overflow-tooltip="true"
          >
            <template slot="header" slot-scope="scope">
              <p>{{ $t("educationId") }}</p>
              <el-input
                v-model="searchData1"
                size="mini"
                placeholder="Search"
                @input="inputSearch"
              />
            </template>
            <template slot-scope="scope">
              {{ scope.row.educationId }}
            </template>
          </el-table-column>
          <el-table-column
            prop="educationName"
            label="教育機関名"
            width="150"
            :show-overflow-tooltip="true"
          >
            <template slot="header" slot-scope="scope">
              <p>{{ $t("educationalInstitution") }}</p>
              <el-input
                v-model="searchData2"
                size="mini"
                placeholder="Search"
                @input="inputSearch"
                clearable
              />
            </template>
            <template slot-scope="scope">
              {{ scope.row.educationName }}
            </template>
          </el-table-column>

          <!--------------機関属性----------------->
          <el-table-column
            prop="attributes"
            label="機関属性"
            width="130px"
            :show-overflow-tooltip="true"
          >
            <template slot="header" slot-scope="scope">
              <p>{{ $t("institutionalAttributes") }}</p>
              <div class="el-dropdown-css-1">
                <el-dropdown @command="handleCommandeducationAttributes">
                  <span class="el-dropdown-link">
                    {{
                      educationAttributesName === ""
                        ? "All"
                        : educationAttributesName
                    }}<i class="el-icon-arrow-down el-icon--right"></i>
                  </span>
                  <el-dropdown-menu slot="dropdown">
                    <el-dropdown-item
                      v-for="(item, index) in educationAttributesData"
                      :key="item.code"
                      :command="item"
                      >{{ item.name }}</el-dropdown-item
                    >
                    <el-dropdown-item command="del">{{
                      $t("cancel")
                    }}</el-dropdown-item>
                  </el-dropdown-menu>
                </el-dropdown>
              </div>
            </template>
            <template slot-scope="scope">
              <span v-if="language === 'CN'">
                {{ scope.row.attributes_dictText }}
              </span>
              <span v-else>
                {{ scope.row.jpattributes_dictText }}
              </span>
            </template>
          </el-table-column>
          <!--------------郵便番号----------------->
          <el-table-column
            prop="postNumber"
            label="郵便番号"
            width="130"
            :show-overflow-tooltip="true"
          >
            <template slot="header" slot-scope="scope">
              <p>{{ $t("postCode") }}</p>
              <el-input
                v-model="searchData3"
                size="mini"
                placeholder="Search"
                @change="mohuSearch"
              />
            </template>
            <template slot-scope="scope">
              <span
                v-if="
                  scope.row.index === tableCellClickRowIndex &&
                    scope.column.index === tableCellClickColumnIndex
                "
              >
                <el-input
                  placeholder="请输入内容…"
                  v-model="scope.row.postNumber2"
                  size="mini"
                  @blur="tableCellInputBlur"
                  autofocus
                />
              </span>
              <span v-else>{{ scope.row.postNumber }}</span>
            </template>
          </el-table-column>
          <!--------------所在地----------------->
          <el-table-column
            prop="address"
            label="所在地"
            width="180"
            :show-overflow-tooltip="true"
          >
            <template slot="header" slot-scope="scope">
              <p>{{ $t("location") }}</p>
              <el-input
                v-model="searchData4"
                size="mini"
                placeholder="Search"
                @change="mohuSearch"
              />
            </template>
            <template slot-scope="scope">
              <span
                v-if="
                  scope.row.index === tableCellClickRowIndex &&
                    scope.column.index === tableCellClickColumnIndex
                "
              >
                <el-input
                  placeholder="请输入内容…"
                  v-model="scope.row.address2"
                  size="mini"
                  @blur="tableCellInputBlur"
                  autofocus
                />
              </span>
              <span v-else>{{ scope.row.address }}</span>
            </template>
          </el-table-column>
          <!--------------代表者----------------->
          <el-table-column
            prop="legalPerson"
            label="代表者"
            :show-overflow-tooltip="true"
          >
            <template slot="header" slot-scope="scope">
              <p>{{ $t("representativeName") }}</p>
              <el-input
                v-model="searchData5"
                size="mini"
                placeholder="Search"
                @change="mohuSearch"
              />
            </template>
            <template slot-scope="scope">
              <span
                v-if="
                  scope.row.index === tableCellClickRowIndex &&
                    scope.column.index === tableCellClickColumnIndex
                "
              >
                <el-input
                  placeholder="请输入内容…"
                  v-model="scope.row.legalPerson2"
                  size="mini"
                  @blur="tableCellInputBlur"
                  autofocus
                />
              </span>
              <span v-else>{{ scope.row.legalPerson }}</span>
            </template>
          </el-table-column>
          <!--------------電話番号----------------->
          <el-table-column
            prop="telephone"
            label="電話番号"
            width="130"
            :show-overflow-tooltip="true"
          >
            <template slot="header" slot-scope="scope">
              <p>{{ $t("telephoneNumber") }}</p>
              <el-input
                v-model="searchData6"
                size="mini"
                placeholder="Search"
                @change="mohuSearch"
              />
            </template>
            <template slot-scope="scope">
              <span
                v-if="
                  scope.row.index === tableCellClickRowIndex &&
                    scope.column.index === tableCellClickColumnIndex
                "
              >
                <el-input
                  placeholder="请输入内容…"
                  v-model="scope.row.telephone2"
                  size="mini"
                  @blur="tableCellInputBlur"
                  autofocus
                />
              </span>
              <span v-else>{{ scope.row.telephone }}</span>
            </template>
          </el-table-column>
          <!--------------授業員数----------------->
          <el-table-column
            prop="teacherNumber"
            label="授業員数"
            width="100"
            sortable
            :show-overflow-tooltip="true"
          >
            <template slot="header" slot-scope="scope">
              <p>{{ $t("numberStaff") }}</p>
              <el-input
                v-model="searchData7"
                size="mini"
                placeholder="Search"
                @change="mohuSearch"
              />
            </template>
            <template slot-scope="scope">
              <span
                v-if="
                  scope.row.index === tableCellClickRowIndex &&
                    scope.column.index === tableCellClickColumnIndex
                "
              >
                <el-input
                  placeholder="请输入内容…"
                  v-model="scope.row.teacherNumber2"
                  size="mini"
                  @blur="tableCellInputBlur"
                  autofocus
                />
              </span>
              <span v-else
                ><span v-if="language === 'CN'">
                  {{ scope.row.teacherNumber_dictText }}
                </span>
                <span v-else>
                  {{ scope.row.jpteacherNumber_dictText }}
                </span></span
              >
            </template>
          </el-table-column>
          <!--------------学生人数----------------->
          <el-table-column
            prop="studentNumber"
            label="学生人数"
            sortable
            :show-overflow-tooltip="true"
          >
            <template slot="header" slot-scope="scope">
              <p>{{ $t("studentNumber") }}</p>
              <el-input
                v-model="searchData8"
                size="mini"
                placeholder="Search"
                @change="mohuSearch"
              />
            </template>
            <template slot-scope="scope">
              <span
                v-if="
                  scope.row.index === tableCellClickRowIndex &&
                    scope.column.index === tableCellClickColumnIndex
                "
              >
                <el-input
                  placeholder="请输入内容…"
                  v-model="scope.row.studentNumber2"
                  size="mini"
                  @blur="tableCellInputBlur"
                  autofocus
                />
              </span>
              <span v-else>
                <span v-if="language === 'CN'">
                  {{ scope.row.studentNumber_dictText }}
                </span>
                <span v-else>
                  {{ scope.row.jpstudentNumber_dictText }}
                </span></span
              >
            </template>
          </el-table-column>
          <!--------------HP SNS----------------->
          <el-table-column
            prop="hpOrSns"
            label="HP SNS"
            width="180"
            :show-overflow-tooltip="true"
          >
            <template slot="header" slot-scope="scope">
              <p>{{ $t("hpOrSns") }}</p>
              <el-input
                v-model="searchData9"
                size="mini"
                placeholder="Search"
                @change="mohuSearch"
              />
            </template>
            <template slot-scope="scope">
              <span
                v-if="
                  scope.row.index === tableCellClickRowIndex &&
                    scope.column.index === tableCellClickColumnIndex
                "
              >
                <el-input
                  placeholder="请输入内容…"
                  v-model="scope.row.hpOrSns2"
                  size="mini"
                  @blur="tableCellInputBlur"
                  autofocus
                />
              </span>
              <span v-else>{{ scope.row.hpOrSns }}</span>
            </template>
          </el-table-column>
          <!--------------求人案件数----------------->
          <el-table-column
            prop="casesNumber"
            label="求人案件数"
            width="130"
            sortable
            :show-overflow-tooltip="true"
          >
            <template slot="header" slot-scope="scope">
              <p>{{ $t("jobCaseNumber") }}</p>
              <el-input
                v-model="searchData10"
                size="mini"
                placeholder="Search"
                @change="mohuSearch"
              />
            </template>
          </el-table-column>
          <!-- -----------------------机构雇员----------------------- -->
          <!--          <el-table-column-->
          <!--            prop="userNumber"-->
          <!--            label="機関スタッフ"-->
          <!--            width="160"-->
          <!--            sortable-->
          <!--          >-->
          <!--            <template slot="header" slot-scope="scope">-->
          <!--              <p>{{ $t("numberOfEmployees") }}</p>-->
          <!--            </template>-->
          <!--          </el-table-column>-->
          <!-- -----------------------机构雇员----------------------- -->
          <el-table-column
            prop="userNumber"
            label="機関スタッフ"
            width="130"
            sortable
            :show-overflow-tooltip="true"
          >
            <template slot="header" slot-scope="scope">
              <p class="operate">{{ $t("numberOfEmployees") }}</p>
            </template>
          </el-table-column>
          <!--------------登録日付----------------->
          <el-table-column
            prop="createTime"
            label="登録日付"
            width="130"
            sortable
            :show-overflow-tooltip="true"
          >
            <template slot="header" slot-scope="scope">
              <p class="operate">{{ $t("registerDay") }}</p>
            </template>
            <template slot-scope="scope">
              <span>
                {{ scope.row.createTime.substring(0, 10) }}
              </span>
            </template>
          </el-table-column>
          <!--------------最新修正日付----------------->
          <el-table-column
            prop="updateTime"
            label="最新修正日付"
            width="130"
            sortable
            :show-overflow-tooltip="true"
          >
            <template slot="header" slot-scope="scope">
              <p class="operate">{{ $t("lastUpdataDay") }}</p>
            </template>
            <template slot-scope="scope">
              <span>
                {{ scope.row.updateTime.substring(0, 10) }}
              </span>
            </template>
          </el-table-column>
          <!--------------ID创设者----------------->
          <el-table-column
            prop="userName"
            label="ID创设者"
            width="130"
            :show-overflow-tooltip="true"
          >
            <template slot="header" slot-scope="scope">
              <p class="operate">{{ $t("idCreater") }}</p>
            </template>
          </el-table-column>
          <!--------------阅览数----------------->
          <el-table-column
            prop="browseNumber"
            label="阅览数"
            width="150"
            sortable
            :show-overflow-tooltip="true"
          >
            <template slot="header" slot-scope="scope">
              <p class="operate">{{ $t("numberOfVisits") }}</p>
            </template>
          </el-table-column>

          <!--------------状態----------------->
          <el-table-column
            prop="status"
            label="状態"
            width="200"
            :show-overflow-tooltip="true"
          >
            <template slot="header" slot-scope="scope">
              <p>{{ $t("status") }}</p>
              <el-input
                v-model="searchData11"
                size="mini"
                placeholder="Search"
                @change="mohuSearch"
              />
            </template>
            <template slot-scope="scope">
              <span v-if="language === 'CN'">
                {{ scope.row.status_dictText }}
              </span>
              <span v-else>
                {{ scope.row.jpstatus_dictText }}
              </span>
            </template>
          </el-table-column>

          <!--------------操作----------------->
          <el-table-column label="操作" fixed="right" width="150">
            <template slot="header" slot-scope="scope">
              <p class="operate">{{ $t("operate") }}</p>
            </template>
            <template slot-scope="scope">
              <el-button type="text" size="mini" v-if="scope.row.status == '1'">
                <button
                  class="save-button"
                  @click="handleUpdateAppStatusOk(scope.row)"
                >
                  yes
                </button>
                <button
                  class="save-button"
                  @click="handleUpdateAppStatusNo(scope.row)"
                >
                  no
                </button>
              </el-button>
              <el-button v-else type="text" size="mini">
                <button class="save-button" @click="handleSaveClick(scope.row)">
                  保存
                </button>
              </el-button>
            </template>
          </el-table-column>
        </el-table>
      </div>

      <!--    分页部分-->
      <div class="pagination">
        <div class="pagination-main">
          <el-pagination
            @current-change="handleCurrentChange"
            :current-page="currentPage"
            layout=" prev, pager, next"
            :total="totalNum"
            :page-size="pageSize"
          >
          </el-pagination>
          <!-- Rows per page -->
          <div class="rowsPage">
            <span>Rows per page</span>
            <div class="rowsPage-css">
              <el-dropdown @command="handleCommand">
                <span class="el-dropdown-link">
                  {{ pageSize
                  }}<i class="el-icon-arrow-down el-icon--right"></i>
                </span>
                <el-dropdown-menu slot="dropdown">
                  <el-dropdown-item command="a">7</el-dropdown-item>
                  <el-dropdown-item command="b">15</el-dropdown-item>
                  <el-dropdown-item command="c">20</el-dropdown-item>
                  <el-dropdown-item command="d">25</el-dropdown-item>
                </el-dropdown-menu>
              </el-dropdown>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import {
  educationAuditUpdate,
  educationInfoFuzzyQuery,
  educationInfoQuery,
  educationOpenUpdate
} from "../../js/api";
import AES from "../../js/AES";
import axios from "axios";

export default {
  name: "adminTalentManagement",
  components: {},
  data() {
    return {
      tableData: [],
      statusData: [],
      multipleSelection: [],
      searchData1: "", //番号
      searchData2: "", //表格第二个搜索
      searchData3: "", //表格第三个搜索
      searchData4: "", //表格第四个搜索
      searchData5: "", //表格第五个搜索
      searchData6: "", //表格第六个搜索
      searchData7: "",
      searchData8: "",
      searchData9: "",
      searchData10: "",
      searchData11: "",
      dropdownData1: "", //第一个下拉
      currentPage: 1, //页数
      pageSize: 7, //每页条数
      loading: false, //table loading
      searchDataStart: "",
      idList: [],
      educationName: this.educationName,
      educationId: this.educationId,
      postNumber: this.postNumber,
      address: this.address,
      legalPerson: this.legalPerson,
      telephone: this.telephone,
      totalNum: 0,
      language: "",
      educationStatus: "",
      educationAttributes: "",
      educationAttributesName: "All",
      educationAttributesCode: "",
      educationAttributesData: [],
      tableCellClickRowIndex: null, // 点击的单元格行索引
      tableCellClickColumnIndex: null // 点击的单元格列索引
    };
  },

  created() {
    //获取当前语言的值
    this.language = window.localStorage.getItem("language");
    console.log("语言选择为" + window.localStorage.getItem("language"));
    console.log("页面语言选择为" + this.language);
    this.getLanguage();
    // 教育机构全部查询 list
    this.allEducationInfo();
    this.getReviewStatus();
    this.geteducationAttributes();
  },
  computed: {},
  destroyed() {
    window.removeEventListener("setItemEvent", this.languageChange, true);
  },
  mounted() {
    window.addEventListener("setItemEvent", this.languageChange, true);
  },
  methods: {
    //监听语言
    languageChange(e) {
      const that = this;
      console.log("------监听数据------");
      console.log(e);
      if (e.key && e.key == "language" && e.newValue) {
        that.language = e.newValue;
        this.allEducationInfo();
        this.getReviewStatus();
        this.geteducationAttributes();
      }
    },
    //获得语言
    getLanguage() {
      if (this.language === "CN") {
        this.educationStatus = "eduStatusChange";
        this.educationAttributes = "educationAttributes";
      } else {
        this.educationStatus = "jpeduStatusChange";
        this.educationAttributes = "jpeducationAttributes";
      }
    },
    //单元格获取焦点
    tableCellClick(row, column, cell, event) {
      this.tableCellClickRowIndex = row.index;
      this.tableCellClickColumnIndex = column.index;
    },
    // 单元格失去焦点
    tableCellInputBlur(row, event, column) {
      this.tableCellClickRowIndex = null;
      this.tableCellClickColumnIndex = null;
    },

    //获取状态数据字典
    getReviewStatus() {
      var that = this;
      that.getLanguage();
      axios
        .get("/api/modules-parent/common/getDateItem", {
          params: {
            dataItem: that.educationStatus
          },
          headers: {
            "content-type": "application/x-www-form-urlencoded",
            token: localStorage.getItem("token")
          }
        })
        .then(function(res) {
          if (res.data.code === "A0000" || res.data.code === "C0252") {
            console.log("--------获取数据字典接口数据review_status--------");
            console.log(res);
            const aesFecInfo = JSON.parse(AES.decrypt(res.data.data));
            // for (var i = 1; i < aesFecInfo.data.length; i++) {
            //   that.statusData[i - 1] = aesFecInfo.data[i];
            // }
            //修复少一个数据字典值bug
            that.statusData = aesFecInfo.data;

            console.log("--------获当然是看获取的状态了--------");

            console.log(that.statusData);
          } else {
            console.log(res.data);
            that.$message.error(res.data.message);
          }
        })
        .catch(res => {
          console.log(res);
        });
    },
    //删除
    deleteEducationInfo() {
      if (this.idList.length == 0) {
        this.$message({
          message: this.$t("selectLeastOneMessage"),
          type: "warning"
        });
      } else {
        const data = {
          address: "",
          attributes: "",
          avatarAddress: "",
          browseNumberin: "",
          browseNumberout: "",
          casesNumber: 0,
          certifiyStatus: 0,
          collectNumber: 0,
          createTime: "",
          createTimein: "",
          createTimeout: "",
          educationId: "",
          educationName: "",
          errorReason: "",
          hpOrSns: "",
          introduction: "",
          isDelete: 0,
          legalPerson: "",
          listId: this.idList,
          pageNumber: 1,
          pageSize: 15,
          postNumber: "",
          reviewTime: "",
          status: 0,
          studentNumber: 0,
          teacherNumber: 0,
          telephone: 0,
          updateTime: "",
          userId: "",
          userName: ""
        };
        axios({
          method: "delete",
          url: "/api/modules-parent/educationInfoQuery/educationDelete",
          data: data,
          headers: {
            token: localStorage.getItem("token")
          }
        })
          .then(res => {
            if (res.data.code === "A0000") {
              this.$message.error("删除成功");
            } else {
              this.$message.error(res.data.message);
              this.$message.error("删除失败");
            }
            console.log(res.data);
            this.allEducationInfo();
          })
          .catch(res => {
            console.log("-----删除后教育机构列表用户接口-----");
            console.error(res);
          });
      }
    },

    //search
    inputSearch() {
      this.mohuSearch();
    },

    //选择行数据
    handleSelectionChange(val) {
      console.log(val);
      this.idList = [];
      for (var i = 0; i < val.length; i++) {
        this.idList.push(val[i].educationId);
      }
      this.multipleSelection = val;
      console.log(this.multipleSelection);
    },

    // 教育机构所有查询 list
    allEducationInfo() {
      const fakeInfo = {
        educationId: "",
        pageNumber: this.currentPage,
        pageSize: this.pageSize
      };
      educationInfoQuery(fakeInfo)
        .then(res => {
          this.tableData = [];
          console.log("----教育机构所有列表信息----");
          console.log(res);
          if (res.data.code === "A0000") {
            const aesFecInfo = JSON.parse(AES.decrypt(res.data.data));
            console.log(aesFecInfo);
            this.totalNum = aesFecInfo.total;
            this.tableData = aesFecInfo.data;
          }
        })
        .catch(res => {
          console.log("----教育机构所有列表信息失败----");
          console.log(res);
        });
    },
    // 教育机构模糊查询 list
    mohuSearch() {
      const fakeInfo = {
        address: this.searchData4,
        attributes: this.attributes,
        browseNumber: 0,
        casesNumber: this.searchData10,
        createTimeIn: "",
        createTimeOut: "",
        educationId: this.searchData1,
        educationName: this.searchData2,
        hpOrSns: this.searchData9,
        legalPerson: "",
        pageNumber: 1,
        pageSize: 15,
        postNumber: this.searchData3,
        status: this.searchData11,
        studentNumber: this.searchData8,
        teacherNumber: this.searchData7,
        telephone: this.searchData6,
        updateTimeIn: "",
        updateTimeOut: "",
        userName: this.searchData5
      };
      educationInfoFuzzyQuery(fakeInfo)
        .then(res => {
          console.log("----教育机构模糊查询列表信息----");
          console.log(res);
          this.tableData = [];
          if (res.data.code === "A0000") {
            const aesFecInfo = JSON.parse(AES.decrypt(res.data.data));
            console.log(aesFecInfo);
            this.tableData = aesFecInfo.data;
          }
        })
        .catch(res => {
          console.log("----教育机构模糊查询列表信息----");
          console.log(res);
        });
    },
    //管理者变更教育机构状态接口
    handleUpdateAppStatus(evt) {

      const adminUpdateJobStatusDTO = {
        educationId: this.idList[0],
        status: evt.code
      };
      console.log(adminUpdateJobStatusDTO);
      educationOpenUpdate(adminUpdateJobStatusDTO)
        .then(res => {
          console.log("--------管理者变更教育状态前接口数据--------");
          console.log(res);
          if (res.data.code === "A0000") {
            // this.$router.go(0)
            const aesFecInfo = JSON.parse(AES.decrypt(res.data.data));
            console.log("解密后信息" + AES.decrypt(res.data.data));
            console.log(aesFecInfo);
            console.log(res);
            this.$message({
              message:aesFecInfo.message,
              type: "success"
            });
            this.allEducationInfo();
          }
        })
        .catch(res => {
          console.log("管理者变更应聘状态接口异常2:", AES.decrypt(res.data.data));
          this.$message.error(AES.decrypt(res.data.data).message);
        });
    },

    //管理者变更教育机构状态OK接口
    handleUpdateAppStatusOk(row) {
      const adminUpdateJobStatusDTO = {
        educationId: row.educationId,
        status: 3
      };
      console.log(adminUpdateJobStatusDTO);
      educationOpenUpdate(adminUpdateJobStatusDTO)
        .then(res => {
          console.log("--------管理者变更教育状态接口ok数据--------");
          console.log(res);
          if (res.data.code === "A0000") {
            const aesFecInfo = JSON.parse(AES.decrypt(res.data.data));
            console.log(aesFecInfo);
            this.$message({
              message: aesFecInfo.message,
              type: "success"
            });
            this.allEducationInfo();
          }
        })
        .catch(res => {
          console.log("管理者变更应聘状态接口异常:", res);
        });
    },

    //管理者变更教育机构状态NO接口
    handleUpdateAppStatusNo(row) {
      const adminUpdateJobStatusDTO = {
        educationId: row.educationId,
        status: 2
      };
      console.log(adminUpdateJobStatusDTO);
      educationOpenUpdate(adminUpdateJobStatusDTO)
        .then(res => {
          console.log("--------管理者变更教育状态接口no数据--------");
          console.log(res);
          if (res.data.code === "A0000") {
            const aesFecInfo = JSON.parse(AES.decrypt(res.data.data));
            console.log(aesFecInfo);
            this.$message({
              message: aesFecInfo.message,
              type: "success"
            });
            this.allEducationInfo();
          }
        })
        .catch(res => {
          console.log("管理者变更应聘状态接口异常1:", res);
          this.$message.error(AES.decrypt(res.data.data).message);
        });
    },
    //table排序
    changeTableSort(column) {
      console.log(column);
      if (column.prop === "minimum") {
        if (column.order === "ascending") {
          this.tableData = this.tableData.sort(
            (a, b) => a["minimum"] - b["minimum"]
          );
        } else {
          this.tableData = this.tableData.sort(
            (a, b) => b["minimum"] - a["minimum"]
          );
        }
      } else if (column.prop === "maximumAmount") {
        if (column.order === "ascending") {
          this.tableData = this.tableData.sort(
            (a, b) => a["maximumAmount"] - b["maximumAmount"]
          );
        } else {
          this.tableData = this.tableData.sort(
            (a, b) => b["maximumAmount"] - a["maximumAmount"]
          );
        }
      } else if (column.prop === "pageView") {
        if (column.order === "ascending") {
          this.tableData = this.tableData.sort(
            (a, b) => a["pageView"] - b["pageView"]
          );
        } else {
          this.tableData = this.tableData.sort(
            (a, b) => b["pageView"] - a["pageView"]
          );
        }
      }
    },
    geteducationAttributes() {
      var that = this;
      that.getLanguage();
      axios
        .get("/api/modules-parent/common/getDateItem", {
          params: {
            dataItem: that.educationAttributes
          },
          headers: {
            "content-type": "application/x-www-form-urlencoded",
            token: localStorage.getItem("token")
          }
        })
        .then(function(res) {
          if (res.data.code === "A0000" || res.data.code === "C0252") {
            console.log(
              "--------获取数据字典接口数据educationAttributes--------"
            );
            console.log(res);
            const aesFecInfo = JSON.parse(AES.decrypt(res.data.data));
            that.educationAttributesData = aesFecInfo.data;
            console.log("--------获当然是看获取的状态了--------");
            console.log(that.educationAttributesData);
          } else {
            console.log(res.data);
            that.$message.error(res.data.message);
          }
        })
        .catch(res => {
          console.log(res);
        });
    },

    //获取educationAttributes下拉
    handleCommandeducationAttributes(evt) {
      if (evt === "del") {
        this.attributes = "";
        this.educationAttributesName = "";
      } else {
        this.attributes = evt.code;
        this.educationAttributesName = evt.name;
      }
      this.mohuSearch();
    },

    handleCurrentChange(evt) {
      this.currentPage = evt;
      this.allEducationInfo();
      console.log(this.currentPage);
    },
    handleCommand(command) {
      if (command === "a") {
        this.pageSize = 7;
        console.log(this.pageSize);
      } else if (command === "b") {
        this.pageSize = 15;
        console.log(this.pageSize);
      } else if (command === "c") {
        this.pageSize = 20;
        console.log(this.pageSize);
      } else if (command === "d") {
        this.pageSize = 25;
        console.log(this.pageSize);
      }
      this.currentPage = 1;
      this.allEducationInfo();
    },
    //行点击
    rowClick(row, column, cell, event) {
      console.log(row);
      console.log("行点击事件");
      if (column.label == "機関番号" || column.label == "教育機関名") {
        this.$router.push({
          path: "/administratorsViewEducationInstitutionsClickDetails",
          query: {
            educationId: row.educationId
          }
        });
      }
    },
    handleAddClick() {
      console.log("＋新たなbutton");
      this.$router.push("/adminAddEducationalInstitutionInformation");
    },
    handleAlterClick() {
      console.log("状態変更button");
    },
    handleDeleteClick() {
      console.log("削除button");
    },

    // 修改判断
    handleSaveClick(row) {
      console.log("保存button");
      if (
        !row.postNumber2 &&
        !row.address2 &&
        !row.legalPerson2 &&
        !row.telephone2 &&
        !row.teacherNumber2 &&
        !row.studentNumber2 &&
        !row.hpOrSns2
      ) {
        this.$message({
          message: this.$t("informationNotModified"),
          type: "warning"
        });
      }
    },
    handleClick(evt) {
      if (evt === "0") {
        //长期
        console.log("长大");
      } else {
        //短期
        console.log("短大");
      }
    }
  }
};
</script>

<style scoped>
.main-css {
  width: 100%;
  height: 100%;
  position: relative;
}
.footer-main {
  width: 100% !important;
}

.main-box {
  /*表格*/
  margin-top: 0px;
  width: 100%;
  height: 0;
  padding: 0 40px 0 80px;
  box-sizing: border-box;
}

.title-css {
  /*标题样式*/
  font-family: "lucida sans unicode", "lucida grande", sans-serif;
  /*字体*/
  color: #686868;
  /*字体颜色*/
  font-size: 2em;
  /*字体大小*/
  text-align: center;
  /*对齐方式*/
  line-height: 76px;
  /*行间距*/
  margin-top: 10px;
}

.line-button-box {
  height: 40px;
  width: 100%;
  display: flex;
  margin-top: 25px;
  margin-left: 40px;
}

.button-css {
  width: 90px;
  height: 35px;
  background: #51abff;
  box-sizing: border-box;
  border-radius: 4px;
  font-weight: 500;
  font-size: 12px;
  color: #fff;
  margin-right: 25px;
  text-align: center;
}

.search button {
  width: 85px;
  height: 24px;
  line-height: 24px;
  background: #fafafa;
  border: 1px solid #51abff;
  box-sizing: border-box;
  border-radius: 8px;
  font-family: "Inter";
  font-style: normal;
  font-weight: 500;
  font-size: 18px;
  color: #51abff;
  cursor: pointer;
  margin-left: 20px;
}

.operate {
  height: 51px;
}

.table {
  position: absolute;
  width: 92%;
  margin-top: 10px;
}

.table /deep/ .el-input__inner {
  border: 1px solid transparent;
  font-family: "Open Sans", serif;
  font-style: normal;
  font-weight: 400;
  font-size: 14px;
  line-height: 20px;
  letter-spacing: 0.25px;
  color: #c9cfda;
  padding: 0;
  text-align: center;
}

.table /deep/ .el-dropdown {
  /*下拉框*/
  width: 60px;
}

.table-img-css {
  border-radius: 50%;
}

.el-dropdown-link {
  /*下拉框*/
  cursor: pointer;
  font-family: "Open Sans";
  font-style: normal;
  font-weight: 400;
  font-size: 14px;
  line-height: 20px;
  letter-spacing: 0.25px;
  color: #00072b;
  width: 100%;
  display: inline-block;
}

.table /deep/ .el-icon-arrow-down {
  float: right;
  height: 20px;
  line-height: 20px;
}

.el-icon-arrow-down {
  font-size: 12px;
}

.table /deep/ .el-table__cell {
  position: relative;
  text-align: center;
}

.table /deep/ .caret-wrapper {
  display: inline-block;
  position: absolute;
  top: -4px;
  right: -48px;
  width: 67px;
}

.save-button {
  width: 69px;
  height: 36px;
  background: #fff;
  border: 1px solid #51abff;
  box-sizing: border-box;
  border-radius: 8px;
  font-family: "Open Sans";
  font-style: normal;
  font-weight: 400;
  font-size: 14px;
  line-height: 10px;
  color: #51abff;
  cursor: pointer;
  margin-right: 10px;
}

.pagination {
  /*分页*/
  width: 95%;
  height: 50px;
  margin-top: 420px;
}

.pagination-main {
  /*分页*/
  float: right;
  margin-right: 10px;
  display: flex;
}

.rowsPage {
  /*RowsPage*/
  height: 30px;
  line-height: 30px;
  font-family: "Open Sans";
  font-style: normal;
  font-weight: 400;
  font-size: 14px;
  letter-spacing: 0.25px;
  color: #454d59;
  display: flex;
  margin-left: 10px;
}

.rowsPage-css {
  width: 60px;
  height: 26px;
  line-height: 26px;
  background: #ffffff;
  border: 1px solid #b0bac9;
  box-sizing: border-box;
  padding: 0 5px 0 10px;
  margin-left: 12px;
}

.rowsPage /deep/ .el-dropdown-link {
  width: 45px;
  height: 26px;
  line-height: 26px;
}

.rowsPage /deep/ .el-icon-arrow-down {
  float: right;
  line-height: 26px;
}
.el-dropdown-css-1 /deep/ .el-dropdown {
  width: 120px !important;
  margin-top: 5px;
  margin-left: -25px;
}
</style>



// WEBPACK FOOTER //
// src/pages/administratorViewEducationalList/index.vue